import { Button, Col, Flex, Row, Typography } from 'antd'
import { Filter } from 'assets/svg'
import Input from 'components/Input'
import { DatepickerValue, InputFieldTypes } from 'components/Input/types'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import { useContext, useEffect, useState } from 'react'
import useSearchForm, { NpvrSearchFormFields } from '../../redux/useSearchForm'
import './index.scss'
import MoreFilters from './MoreFilters'
import { MultipleSearchFilter, STATUS_OPTIONS } from './types'

type MultipleSearchProps = {
  onSearch: (filters: MultipleSearchFilter) => void
}

export default function MultipleSearch({onSearch}: MultipleSearchProps) {
  const t = useContext(I18nContext)
  const {stringSearchForm, dateSearchForm , setStringSearchForm, setDateSearchForm, resetState} = useSearchForm()
  const [showMoreFilters, setShowMoreFilters] = useState(false)
  const [filterIsDirty, setFilterIsDirty] = useState(false)

  const setStringValue = (key: NpvrSearchFormFields, value: string) => {
    setStringSearchForm((currentState) => {
      return new Map(currentState.set(key,value))
    })
  }

   const setDateValue = (key: NpvrSearchFormFields, value: DatepickerValue) => {
    setDateSearchForm((currentState) => {
      return new Map(currentState.set(key,value))
    })
  }

  const onSearchHandle = () => {
    onSearch({stringSearchForm, dateSearchForm})
  }

  useEffect(() => {
    let filterIsDirty = false
    if(stringSearchForm){
      stringSearchForm.forEach((value) => {
        if(value){
          filterIsDirty = true
        }
      })
    }

    if(dateSearchForm){
      dateSearchForm.forEach((value) => {
        if(value.start && value.end){
          filterIsDirty = true
        }
      })
    }

    setFilterIsDirty(filterIsDirty)

  }, [stringSearchForm, dateSearchForm])
  
  return (
   <div>
    <Typography.Title level={2} className='npvr-title'>{t('home.icon_npvr')}</Typography.Title>
    <Row gutter={16}>
      <Col span={3}>
        <Input
          type={InputFieldTypes.text}
          value={stringSearchForm.get(NpvrSearchFormFields.asset)}
          setValue={(value) => setStringValue(NpvrSearchFormFields.asset, value)}
          labelParams={{
            i18nTag: 'dvr.field_asset',
            onClean: () => setStringValue(NpvrSearchFormFields.asset, '')
          }}
        />
      </Col>
      <Col span={3}>
        <Input
          type={InputFieldTypes.text}
          value={stringSearchForm.get(NpvrSearchFormFields.programId)}
          setValue={(value) => setStringValue(NpvrSearchFormFields.programId, value)}
          labelParams={{
            i18nTag: 'dvr.field_programId',
            onClean: () => setStringValue(NpvrSearchFormFields.programId, '')
          }}
        />
      </Col>
      <Col span={5}>
        <Input
          type={InputFieldTypes.text}
          value={stringSearchForm.get(NpvrSearchFormFields.program)}
          setValue={(value) => setStringValue(NpvrSearchFormFields.program, value)}
          labelParams={{
            i18nTag: 'dvr.field_program',
            onClean: () => setStringValue(NpvrSearchFormFields.program, '')
          }}
        />
      </Col>
      <Col span={5}>
        <Input
          type={InputFieldTypes.text}
          value={stringSearchForm.get(NpvrSearchFormFields.episode)}
          setValue={(value) => setStringValue(NpvrSearchFormFields.episode, value)}
          labelParams={{
            i18nTag: 'dvr.field_episode',
            onClean: () => setStringValue(NpvrSearchFormFields.episode, '')
          }}
        />
      </Col>
      <Col span={5}>
        <Input 
        type={InputFieldTypes.select}
        options={STATUS_OPTIONS}
        setValue={(value) => setStringValue(NpvrSearchFormFields.status, value)}
        value={stringSearchForm.get(NpvrSearchFormFields.status)}
        labelParams={{
          i18nTag: 'dvr.field_status',
          onClean: () => setStringValue(NpvrSearchFormFields.status, STATUS_OPTIONS[0].value)
        }}
        />
      </Col>
      <Col span={3} style={{display:'flex', alignItems:'flex-start', justifyContent:'flex-start'}}>
      <Button onClick={onSearchHandle}  className='filter-search-button' type='primary' style={{height:40, marginRight:10, flex:1}}>
        {t('general.search')}
      </Button>
      <Button 
        type='default' 
        shape='circle' 
        style={{height:40, width:40, borderColor:'#e60000'}} 
        onClick={() => setShowMoreFilters((currentState) => !currentState)}>
          <Filter className="icon-svg" style={{width:28, height:28, stroke:'#e60000', padding:4}}/>
      </Button>
      </Col>
    </Row>
    <MoreFilters 
      dateSearchForm={dateSearchForm} 
      stringSearchForm={stringSearchForm} 
      showMoreFilters={showMoreFilters} 
      setDateValue={setDateValue} 
      setStringValue={setStringValue}
    />
    <Flex justify={'flex-end'}>
      {filterIsDirty &&  <Button className='clear-filter-button' type='link' onClick={() => {
        setShowMoreFilters(false)
        resetState()
      }}>{t('general.clear_filters')}</Button>}
    </Flex>
   </div>
  )
}
